module.exports = "<p>\n  home works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main